import { render } from "./SalaSelector.vue?vue&type=template&id=385ae598&scoped=true"
import script from "./SalaSelector.vue?vue&type=script&lang=js"
export * from "./SalaSelector.vue?vue&type=script&lang=js"

import "./SalaSelector.vue?vue&type=style&index=0&id=385ae598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385ae598"]])

export default __exports__